import { useCallback } from 'react';
import { useFetch } from '@bingads-webui-campaign-react/campaign-http';
import videoTemplatesLocalized from '../../localize/video-templates';

export const useCopilotDomainDataService = () => {
  const { post } = useFetch();

  const fetchData = useCallback(async (url, params) => {
    try {
      const response = await post(url, params);
      return { response, error: null };
    } catch (error) {
      return { response: null, error };
    }
  }, [post]);

  const getAudioListWithFilter = useCallback((filter) => {
    const url = 'v13/SupportedClipchampAudio/Query';
    return fetchData(url, { Mock: false, AudioFilter: filter });
  }, [fetchData]);

  const getVideoTemplateListWithFilter = useCallback((templateFilter) => {
    const url = 'v13/ClipchampTemplates/Query';
    return fetchData(url, { Mock: false, TemplateFilter: templateFilter });
  }, [fetchData]);

  return {
    getAudioListWithFilter,
    getVideoTemplateListWithFilter,
  };
};

export const useCopilotDomainDataRepository = () => {
  const {
    getAudioListWithFilter,
    getVideoTemplateListWithFilter,
  } = useCopilotDomainDataService();

  const getAudioList = useCallback(filter => getAudioListWithFilter(filter), [getAudioListWithFilter]);

  const getVideoTemplates = useCallback(async (templateFilter, i18n) => {
    try {
      const { response, error } = await getVideoTemplateListWithFilter(templateFilter);

      if (error || !response) {
        return { response, error };
      }

      if (!i18n) {
        return { response, error: null }; // If i18n is not available, return templates without localization
      }

      const localizedTemplates = videoTemplatesLocalized(i18n);

      const updatedTemplates = response.Templates.map((template) => {
        const localizedTemplate = localizedTemplates[template.TemplateId];
        return {
          ...template,
          ...localizedTemplate,
        };
      });

      return { response: { Templates: updatedTemplates }, error: null };
    } catch (error) {
      return { response: null, error };
    }
  }, [getVideoTemplateListWithFilter]);

  return {
    getAudioList,
    getVideoTemplates,
  };
};
